import { ActivityTab, ActivityIntervalOption, SortOption } from '../../models/fund/activity.model';

export const ACTIVITY_TABS: ActivityTab[] = [
  { id: 'summary', labelKey: 'activity.body.summary', field: 'all' },
  { id: 'contributions', labelKey: 'activity.body.my_contributions', field: 'contributions' },
  { id: 'transfers', labelKey: 'activity.body.my_transfers', field: 'transfers' },
  { id: 'grants', labelKey: 'activity.body.my_grants', field: 'grants' },
  { id: 'other-activities', labelKey: 'activity.body.other_activities', field: 'otherActivities' },
  { id: 'pending', labelKey: 'activity.body.pending_transactions', field: 'pending' },
];

export interface ActivityIntervalOptionItem {
  id: ActivityIntervalOption;
  labelKey: string;
  getRange: () => { start: number; end: number };
}

export const ACTIVITY_INTERVAL_OPTIONS: ActivityIntervalOptionItem[] = [
  {
    id: 'ALL_TIME',
    labelKey: 'activity.body.all_time',
    getRange: () => {
      const end = new Date();
      end.setUTCHours(23, 59, 59, 999);
      return { start: 1546300800000, end: end.getTime() };
    },
  },
  {
    id: 'CUSTOM',
    labelKey: 'activity.body.custom_range',
    getRange: () => {
      const end = new Date();
      end.setUTCHours(23, 59, 59, 999);
      return { start: 1546300800000, end: end.getTime() };
    },
  },
  {
    id: 'LAST_30_DAYS',
    labelKey: 'activity.body.last_30_days',
    getRange: () => {
      const end = new Date();
      end.setUTCHours(23, 59, 59, 999);
      const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000);
      start.setUTCHours(0, 0, 0, 0);
      return { start: start.getTime(), end: end.getTime() };
    },
  },
  {
    id: 'LAST_90_DAYS',
    labelKey: 'activity.body.last_90_days',
    getRange: () => {
      const end = new Date();
      end.setUTCHours(23, 59, 59, 999);
      const start = new Date(end.getTime() - 90 * 24 * 60 * 60 * 1000);
      start.setUTCHours(0, 0, 0, 0);
      return { start: start.getTime(), end: end.getTime() };
    },
  },
  {
    id: 'THIS_MONTH',
    labelKey: 'activity.body.this_month',
    getRange: () => {
      const n = new Date();
      return {
        start: Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), 1, 0, 0, 0, 0),
        end: Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate(), 23, 59, 59, 999),
      };
    },
  },
  {
    id: 'LAST_MONTH',
    labelKey: 'activity.body.last_month',
    getRange: () => {
      const n = new Date();
      const y = n.getUTCFullYear();
      const m = n.getUTCMonth();
      return {
        start: Date.UTC(y, m - 1, 1, 0, 0, 0, 0),
        end: Date.UTC(y, m, 0, 23, 59, 59, 999),
      };
    },
  },
  {
    id: 'THIS_YEAR',
    labelKey: 'activity.body.this_year',
    getRange: () => {
      const n = new Date();
      return {
        start: Date.UTC(n.getUTCFullYear(), 0, 1, 0, 0, 0, 0),
        end: Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate(), 23, 59, 59, 999),
      };
    },
  },
  {
    id: 'LAST_YEAR',
    labelKey: 'activity.body.last_year',
    getRange: () => {
      const y = new Date().getUTCFullYear() - 1;
      return {
        start: Date.UTC(y, 0, 1, 0, 0, 0, 0),
        end: Date.UTC(y, 11, 31, 23, 59, 59, 999),
      };
    },
  },
];

export const ACTIVITY_SORT_OPTIONS: SortOption[] = [
  { field: 'date', labelKey: 'Date' },
  { field: 'amount', labelKey: 'Amount' },
  { field: 'description', labelKey: 'Description' },
  { field: 'location', labelKey: 'Location' },
];

export const TRANSACTION_TAB_TYPES = {
  CONTRIBUTIONS: 'contributions',
  GRANTS: 'grants',
  TRANSFERS: 'transfers',
  OTHER_ACTIVITIES: 'otherActivities',
  PENDING: 'pending',
} as const;
